module.exports = __webpack_public_path__ + "img/medal_bronze.10423aef.png";